import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const Contact: React.FC = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Kontakt PODO FEET",
    "description": "Kontaktieren Sie PODO FEET für Terminvereinbarungen und Fragen zur Fusspflege",
    "mainEntity": {
      "@type": "LocalBusiness",
      "name": "PODO FEET - Maya Kälin",
      "telephone": "+41774049528",
      "email": "maya.kaelin@bluewin.ch",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Dorfplatz 6",
        "addressLocality": "Altendorf", 
        "postalCode": "8852",
        "addressCountry": "CH"
      },
      "openingHours": "Mo-Su by appointment",
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "47.189583",
        "longitude": "8.819238"
      }
    }
  };

  

  

  return (
    <>
      <SEO
        title="Kontakt | PODO FEET - Termin vereinbaren für Fusspflege in Altendorf"
        description="Kontaktieren Sie PODO FEET für Terminvereinbarungen. Telefon: +41 77 404 95 28, E-Mail: maya.kaelin@bluewin.ch. Dorfplatz 6, 8852 Altendorf."
        keywords="Kontakt PODO FEET, Termin Fusspflege, Altendorf Terminvereinbarung, Maya Kälin Kontakt, Fusspflege buchen"
        url="https://podo-feet.ch/kontakt"
        structuredData={structuredData}
      />

      {/* Hero Banner */}
      <section className="relative bg-primary py-16">
        <div className="container-custom relative z-10">
          <h1 className="heading-1 text-white mb-4">Kontakt</h1>
          <div className="flex items-center text-white/90">
            <Link to="/" className="hover:text-white">Startseite</Link>
            <span className="mx-2">›</span>
            <span>Kontakt</span>
          </div>
        </div>
      </section>

      {/* Kontaktinformationen & Formular */}
      <section className="section bg-white">
        <div className="container-custom">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Kontaktinformationen */}
            <div>
              <h2 className="heading-2 text-primary mb-6">Kontaktieren Sie mich</h2>
              <p className="mb-6">
                Sie haben Fragen zu meinen Leistungen oder möchten einen Termin vereinbaren? 
                Kontaktieren Sie mich gerne per Telefon, E-Mail oder über das Kontaktformular. 
                Ich freue mich auf Ihre Nachricht und melde mich zeitnah bei Ihnen zurück.
              </p>

              <div className="space-y-6 mt-8">
                <div className="flex items-start">
                  <div className="bg-lightGreen p-3 rounded-full mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-darkGreen" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-1">Telefon</h3>
                    <a href="tel:+41774049528" className="text-gray-700 hover:text-primary transition-colors">
                      +41 77 404 95 28
                    </a>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-lightGreen p-3 rounded-full mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-darkGreen" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-1">E-Mail</h3>
                    <a href="mailto:maya.kaelin@bluewin.ch" className="text-gray-700 hover:text-primary transition-colors">
                      maya.kaelin@bluewin.ch
                    </a>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-lightGreen p-3 rounded-full mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-darkGreen" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-1">Adresse</h3>
                    <address className="text-gray-700 not-italic">
                      PODO FEET - Maya Kälin<br />
                      Dorfplatz 6<br />
                      8852 Altendorf
                    </address>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-lightGreen p-3 rounded-full mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-darkGreen" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-1">Öffnungszeiten</h3>
                    <p className="text-gray-700">Nach Vereinbarung</p>
                  </div>
                </div>
              </div>

              <div className="mt-10">
                <h3 className="text-xl font-semibold text-primary mb-4">Standort</h3>
                <div className="bg-gray-200 rounded-lg overflow-hidden shadow-lg">
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2709.7229672766394!2d8.81923871595271!3d47.189583821673644!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479ab6e8e7f6ea11%3A0xf9c9d383dd319b74!2sDorfpl.%206%2C%208852%20Altendorf%2C%20Schweiz!5e0!3m2!1sde!2sde!4v1651236555842!5m2!1sde!2sde" 
                    width="100%" 
                    height="300" 
                    style={{ border: 0 }} 
                    allowFullScreen 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                    title="PODO FEET Standort"
                  ></iframe>
                </div>
              </div>
            </div>

            
          </div>
        </div>
      </section>

      
    </>
  );
};

export default Contact; 